import { Component, OnInit, EventEmitter, ViewChild } from '@angular/core';
import { XPRESS_LOAN} from 'src/models/xpress_loan.model';
import { CREDITCARD_LOAN11 } from 'src/models/creditcard_loan.model';
import { VEHICLE_LOAN,} from 'src/models/vehicle_loan.model';
import { LoanTypeEnum } from 'src/models/loan-type.enum';
import { PERSONAL_LOAN } from 'src/models/personal_loan.model';
import { ApplicantService } from 'src/shared/applicant.service';
import { AuthService } from 'src/shared/auth.service';
import { CommonService } from 'src/shared/common.service';
import { ValidationErrors } from '@angular/forms';
import { StepOneComponent } from 'src/components/step-one/step-one.component';
import * as $ from 'jquery';
import * as _ from 'lodash';
import { base_applicant_type, BASE_CUSTOM_QUESTIONSCUSTOM_QUESTION} from 'src/models/common.model';
import { AppComponent } from '../app.component';
import { JointApplicantModalComponent } from 'src/components/step-one/joint-applicant-modal/joint-applicant-modal.component';
import { ApiService } from 'src/shared/api.service';
import { ActivatedRoute } from '@angular/router';
import { Util } from 'src/shared/util';
import { zip } from 'rxjs';




@Component({
  selector: 'app-applicant-loan',
  templateUrl: './applicant-loan.component.html',
  styleUrls: ['./applicant-loan.component.css']
})
export class ApplicantLoanComponent implements OnInit {

  steps = [
    {
      id: 1,
      headerText: "Application"
    },
    {
      id: 2,
      headerText: "Review"
    },
    {
      id: 3,
      headerText: "Confirm"
    }
  ]

  public static currentStepId: any;
  submitHistory: any;

  creditCardLoan: CREDITCARD_LOAN11;
  vehicleLoan: VEHICLE_LOAN;
  personalLoan: PERSONAL_LOAN;

  xpressLoan: XPRESS_LOAN = new XPRESS_LOAN();

  eligibilityModel ={
    qualifyingEmployer:{},
    eligibilityRelationship:{
      isChecked: false,
      name:"",
      phone:"",
    },
    employee_of_lender_type:{
      isChecked: false
    }
  }

  selectedLoanType: LoanTypeEnum;
  selectedProducts = [];
  soResponses: any ;
  public static addJointApp: EventEmitter<any> = new EventEmitter<any>();

  public static copyAddressFromMainApp: EventEmitter<boolean> = new EventEmitter<boolean>();

  public static forceFinalPageError = false;

  public static currentChannel: any;
  public static refChannel : string = '';
  public static pcQuery : string = '';

  public static isCoBrand = false;

  public static defaultPrimarySavingProduct;

  public static sessionId = '';

  validationErrors: ValidationErrors = {};

  public entity_Token = "";
  public journeyApplicationToken = "";
  public static onUploadAlloyDocumentComplete: EventEmitter<any> = new EventEmitter<any>();

  AppComponent =  AppComponent;
  ApplicantLoanComponent = ApplicantLoanComponent;
  customQuestions: BASE_CUSTOM_QUESTIONSCUSTOM_QUESTION[] = [
    //hearAboutUsModel 0
    {
      CUSTOM_QUESTION_ANSWER: [{ answer_text: "", answer_value: "" }],
      question_name: "{REFERRAL}",
      question_type: "DROPDOWN"
    },
    // promotion code 1
    {
      CUSTOM_QUESTION_ANSWER: [{ answer_text: "", answer_value: "" }],
      question_name: "{PROMO}",
      question_type: "TEXTBOX"
    },
    // WITHHOLDING 2
    {
      CUSTOM_QUESTION_ANSWER: [],
      question_name: "{WITHHOLDING}",
      question_type: "DROPDOWN"
    },

    // consent 3
    {
      CUSTOM_QUESTION_ANSWER: [],
      question_name: "{TCPA}",
      question_type: "DROPDOWN"
    },

    //consentToContactMP 4
    {
      CUSTOM_QUESTION_ANSWER: [],
      question_name: "{TCPA_MKT}",
      question_type: "DROPDOWN"
    },


    //Text Opt-In 5
    {
      CUSTOM_QUESTION_ANSWER: [],
      question_name: "Text Opt-In",
      question_type: "DROPDOWN"
    },

    //APPFROM 6
    {
      CUSTOM_QUESTION_ANSWER: [{ answer_text: "ONLINE", answer_value: "ONLINE" }],
      question_name: "{APPFROM}",
      question_type: "CHECKBOX"
    },

  
  ];


  constructor(private applicantService: ApplicantService, private authService: AuthService, private commonService: CommonService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private activatedRoute: ActivatedRoute) {
    try{
      this.authService.getToken().subscribe(async r => {
        this.commonService.accessToken = r.access_token;    
      })
    }catch{}
    finally{
      this.xpressLoan.version  = 5.248;     
      ApplicantLoanComponent.currentStepId = 1;
    }

    this.route.queryParams.subscribe(params => {
      ApplicantLoanComponent.refChannel = params['ref'];
      ApplicantLoanComponent.pcQuery = params['pc']?.toLowerCase();
      zip(this.apiService.getChannelByCurrentUri(ApplicantLoanComponent.refChannel),
          this.apiService.getEmployerNames()).subscribe(([r1, r2])=>{
            if(r1 && r2){
              ApplicantLoanComponent.currentChannel = r1;
              ApplicantLoanComponent.isCoBrand = r1.channelTypeId == 3 && r1.isActive;
              var employerName = _.find(r2, em => em.channelId == ApplicantLoanComponent.currentChannel.id);
              if(ApplicantLoanComponent.isCoBrand){
                if(ApplicantLoanComponent.currentChannel.channelName && employerName){
                  this.eligibilityModel.qualifyingEmployer ={displayName:employerName.displayName, value:employerName.value}
                }else{
                  this.eligibilityModel.qualifyingEmployer ={displayName:'Surfrider Foundation', value:4018}
                }
                let questionAppFrom = _.find(this.customQuestions, cq=>{
                  return cq.question_name == '{APPFROM}'
                }) 
                var section = _.find(ApplicantLoanComponent.currentChannel.channelSectionSubscriptions, css=>{
                  return css.sectionId == 1;
                })
                if(section){
                  var md = JSON.parse(section.metaData);
                  questionAppFrom.CUSTOM_QUESTION_ANSWER = [{ answer_text: md.name, answer_value: md.value }]
    
                  this.customQuestions.push(
                    {
                      CUSTOM_QUESTION_ANSWER: [{ answer_text: md.name, answer_value: md.value }],
                      question_name: "BDOREFERRAL",
                      question_type: "DROPDOWN"
                    },
                  )
                }
               
                  // $('#bg-main-id').css('color', 'black');   
                  // $('#bg-main-id').css('background-color', 'black');    
                  if(ApplicantLoanComponent.currentChannel.accentColor){
    
                    $('#bg-main-id').css('background-image', `linear-gradient(to top right,${ApplicantLoanComponent.currentChannel.accentColor.split('-')[0]},${ApplicantLoanComponent.currentChannel.accentColor.split('-')[1]} )`);
                  }
                  
                
                
              }
            }
          })
     
      

  });



  }

  ngOnInit(): void {
    ApplicantLoanComponent.sessionId = Util.generateId();
   

    const _this = this;
    window.addEventListener("beforeunload", function (e) {
      var confirmationMessage = "If you proceed then your form won't be saved and you will have to refill the form.";  
      if(ApplicantLoanComponent.currentStepId ==2.5){
        try{
          var fundingLog = {
            appId : _this.submitHistory.XAId,
            submitHistoryId : _this.submitHistory.id,
            appEvent : "Try to close funding page",
          } as any;
          _this.apiService.saveFundingLog(fundingLog).subscribe(r=>{})
        }catch{}
      }
      e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
          return confirmationMessage;              // Gecko, WebKit, Chrome <34
      });



    this.initData();
    this.creditCardLoan = this.applicantService.initDataCreditCard();
    
    //For type 2
    var applicationType = this.activatedRoute.snapshot.queryParams["at"];
    var ltId = this.activatedRoute.snapshot.queryParams["lt"];

    if(applicationType && applicationType == 2 && ltId && ltId == 6){
      this.personalLoan = this.applicantService.initDataPersonal();
    }
    if(applicationType && applicationType == 2 && ltId && ltId == 5){
      this.vehicleLoan = this.applicantService.initDataVehicle();
    }
    ApplicantLoanComponent.addJointApp.subscribe(r => {

      //joint applicant
      this.creditCardLoan.APPLICANTS.APPLICANT[0].SPOUSE = r.creditCardApplicant;
      //SET APPLICANT_TYPE FOR DECISION
      this.creditCardLoan.APPLICANTS.APPLICANT[0].SPOUSE.applicant_type = base_applicant_type.C;
      this.xpressLoan.APPLICANTS[0].SPOUSE = r.xpressApplicant;


      if(this.vehicleLoan){
        this.vehicleLoan.APPLICANTS.APPLICANT[0].SPOUSE  = r.vehicleApplicant;
        this.vehicleLoan.APPLICANTS.APPLICANT[0].SPOUSE.applicant_type = base_applicant_type.C;
      }
      if(this.personalLoan){
        this.personalLoan.APPLICANTS.APPLICANT[0].SPOUSE = r.personalApplicant;
        this.personalLoan.APPLICANTS.APPLICANT[0].SPOUSE.applicant_type = base_applicant_type.C;
      }


     if(this.xpressLoan.APPLICANTS[0].SPOUSE.ssn === this.xpressLoan.APPLICANTS[0].ssn){

        this.validationErrors.ssn =  {
          'hasSamessn': 'hasSamessn'
         } as ValidationErrors;
     }else{
        delete  this.validationErrors.ssn ;
     }
    })

    ApplicantLoanComponent.copyAddressFromMainApp.subscribe(r=>{
      JointApplicantModalComponent.copyAddressFromMainApp.emit(this.creditCardLoan.APPLICANTS.APPLICANT[0]);
    })

  }

  initData() {
    this.xpressLoan.SYSTEM =[
      {
        BRANCH: {
          name: "test"
        } as any
      } as any
    ]
    this.xpressLoan.LOAN_INFO = {
      requirement_description_value: "",
    } as any;
    this.xpressLoan.APPLICANTS = [this.applicantService.initXpressApplicant()];
    this.xpressLoan.COMMENTS = {} as any;
  }

  productsHaveChanged(e) {
    this.selectedProducts = _.uniqBy(e, 'id'); 
    var ccLoanProduct = _.find(this.selectedProducts, {loan_type: LoanTypeEnum.CC, productGroupId:4});
    if(ccLoanProduct!=null){
      this.creditCardLoan.LOAN_INFO.requested_card_name = this.creditCardLoan.LOAN_INFO.card_name  = ccLoanProduct.name;
      this.creditCardLoan.LOAN_INFO.purpose_type= "New Card";   
    }
  }

  // scrollToTopPage() {
  //   $("html, body").stop().animate({ scrollTop: 0 }, 500, 'swing'); //scropTop of page
  // }
  
  handleEntityTokenChange(eventData : any){
    this.entity_Token = eventData.entityToken;
    this.journeyApplicationToken = eventData.journeyApplicationToken;
    ApplicantLoanComponent.currentStepId = 2.1;
  }
  
  onUploadCompleted(event){
    ApplicantLoanComponent.currentStepId = 2;
    ApplicantLoanComponent.onUploadAlloyDocumentComplete.emit(event);
  }

  vehicleLoanChange(e){
    this.vehicleLoan = e;
  }
  personalLoanChange(e){
    this.personalLoan = e;
  }

  submitHistoryChanged(event){
    this.submitHistory = event.submitHistory;
    if(event.selectedLoanType){
      this.selectedLoanType = event.selectedLoanType;
    }
    if(event.soResponses){
      this.soResponses = event.soResponses;
    }
  }

}
